import { FC, useState } from 'react';
import { Loader2Icon, SendIcon } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router';
import { toast } from 'sonner';
import axios from 'axios';

import { API_BASE_URL } from '@/constants';
import { NbButton, NbCard, NbField, NbPageHeader } from '@/components/Neobrut';

export const ResetPassword: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ new_password: string; confirm_password: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = async (data: { new_password: string; confirm_password: string }) => {
    if (data.new_password !== data.confirm_password) {
      toast.error('Las contraseñas no coinciden');
      return;
    }

    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const email = params.get('email');
    if (!token || !email) return;

    setIsLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/users/set-new-password/`, {
        token,
        email,
        new_password: data.new_password,
      });
      if (response.status === 200) {
        toast.success(response.data.message);
        navigate('/login');
      }
    } catch {
      // error already handled via interceptor/toast elsewhere.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mx-auto w-full max-w-md pb-10">
      <NbPageHeader
        slug="/ reset-password"
        title={
          <>
            Nueva
            <br />
            <span className="nb-highlight">contraseña.</span>
          </>
        }
        tone="plain"
      />
      <form onSubmit={handleSubmit(onSubmit)} className="px-4 pt-4">
        <NbCard className="flex flex-col gap-4 p-4">
          <NbField
            id="new_password"
            label="Nueva contraseña"
            type="password"
            autoComplete="new-password"
            error={errors.new_password?.message}
            {...register('new_password', { required: 'El campo es requerido' })}
          />
          <NbField
            id="confirm_password"
            label="Confirmar contraseña"
            type="password"
            autoComplete="new-password"
            error={errors.confirm_password?.message}
            {...register('confirm_password', { required: 'El campo es requerido' })}
          />
          <NbButton fill="ink" type="submit" className="w-full py-3" disabled={isLoading}>
            {isLoading ? (
              <Loader2Icon className="h-4 w-4 animate-spin" />
            ) : (
              <SendIcon size={14} />
            )}
            Guardar
          </NbButton>
        </NbCard>
      </form>
    </div>
  );
};
